export const INCENTIVE_BASE_PATH = '/incentive';

export const DATE_ERROR_TEXT = 'End date must be after Begin date';

export const MANDATORY_FIELD_ERROR_TEXT = 'This field is mandatory';
export const CHOOSE_ONE_ERROR_TEXT = 'One of the fields must be filled';

export const DATE_FORMAT_ERROR_TEXT = 'Invalid date format';

export const NET_CASE_TEXT = "Net Case";
export const NET_AFYP_TEXT = "Total Net AFYP";

//  These constants map to aside menu, header menu to display title
export const INCENTIVE_TITLE = "title.incentive";

//  These constants map to permission control, identical to permission enum defined below
export const INCENTIVE_NAMESPACE = "INCENTIVE";

export enum AdminIncentivePermissionType {
  INCENTIVE_READ = "READ_ANY_INCENTIVE",
  INCENTIVE_CREATE = "CREATE_ANY_INCENTIVE",
  INCENTIVE_UPDATE = "UPDATE_ANY_INCENTIVE"
};